// extracted by mini-css-extract-plugin
export default {"addToCart":"AddToCart_addToCart__ubcLs","add":"AddToCart_add__bz598"};